import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    CircularProgress, Grid, IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {getAddresse, getDataInString} from "../RightAccordion";
import IconesRight from "../../pages/compos/IconesRight";
import InfoIcon from "@mui/icons-material/Info";
import IconMaison from "../../ico/IconMagasin";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import HeightIcon from "@mui/icons-material/Height";
import IconEtage2 from "../../ico/IconEtage2";
import IconMSquare2 from "../../ico/IconMSquare2";
import IconMur from "../../ico/IconMur";
import IconToit from "../../ico/IconToit";
import {resBdnb} from "../AttributBdnb";


function getListOfPrpprietaires(proprietaires) {
    let res = []
    proprietaires.forEach(element => {
        let n = ""
        if(element?.forme_juridique) {
            n += element?.forme_juridique + " "
        }
        if(element?.denomination) {
            n += element?.denomination + " "
        }
        if(element?.siren) {
            n += "(" + element?.siren + ")"
        }
        if (element?.nb_locaux_open){
            n += " - "+ element.nb_locaux_open + " loc."
        }
        res.push(n)
    })
    return res.join("<br>");
}

export default function ProprioDetails({selectedItem}) {
    const [open, setOpen] = React.useState(true);

    return (<Box>
            <Box sx={{
                width: "90%",
                borderRadius: "8px",
                backgroundColor: "#f7f9fc",
                padding: 2,
                m: 1,
            }}>
                <Box sx={{
                    display: "flex",
                    width: "100%",
                    borderColor: "#000",
                    borderBottomStyle: "solid",
                    height: 30
                }}>
                    <Typography>STATUT DE PROPRIETE DU BATIMENT</Typography>
                </Box>

                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Société ou collectivité propriétaire</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {selectedItem.proprietaires.length > 0 ? "Oui" : "Non"}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Dénomination sociale</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom
                                    dangerouslySetInnerHTML={{__html: getListOfPrpprietaires(selectedItem.proprietaires)}}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

